export const USER_ROLES = ['admin', 'viewer'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const AGENT_STATUSES = [
  'active',
  'busy',
  'scheduled',
  'onboarding',
  'inactive',
] as const;
export type AgentStatus = (typeof AGENT_STATUSES)[number];

export const RULE_SCOPES = ['global', 'department', 'agent', 'user'] as const;
export type RuleScope = (typeof RULE_SCOPES)[number];

export const RULE_STATUSES = ['active', 'superseded', 'archived', 'absorbed'] as const;
export type RuleStatus = (typeof RULE_STATUSES)[number];

export const KNOWLEDGE_SCOPES = ['agent', 'department', 'global'] as const;
export type KnowledgeScope = (typeof KNOWLEDGE_SCOPES)[number];

export const PROPOSAL_KINDS = ['retire_skill', 'spec_amendment', 'promote_knowledge'] as const;
export type ProposalKind = (typeof PROPOSAL_KINDS)[number];

export const PROPOSAL_STATUSES = ['pending', 'approved', 'rejected'] as const;
export type ProposalStatus = (typeof PROPOSAL_STATUSES)[number];

export const SKILL_SCOPES = ['global', 'dynamic'] as const;
export type SkillScope = (typeof SKILL_SCOPES)[number];

export const TRIGGER_TYPES = [
  'slack_interactive',
  'background',
  'schedule',
  'dispatch',
  'think_harder',
  'dashboard',
] as const;
export type TriggerType = (typeof TRIGGER_TYPES)[number];

export const ACTIVITY_KINDS = [
  'dispatch',
  'agent_run',
  'session_opened',
  'session_closed',
] as const;
export type ActivityKind = (typeof ACTIVITY_KINDS)[number];

export const SESSION_STATUSES = ['open', 'resolved'] as const;
export type SessionStatus = (typeof SESSION_STATUSES)[number];

export const LLM_ENV_KEYS = [
  'N8N_DEFAULT_LLM',
  'N8N_FAST_LLM',
  'N8N_THINKING_LLM',
  'N8N_LOCAL_DEFAULT_LLM',
  'N8N_LOCAL_FAST_LLM',
  'N8N_LOCAL_THINKING_LLM',
] as const;
export type LlmEnvKey = (typeof LLM_ENV_KEYS)[number];
